import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertThenFormat } from "../../common-data/Converts";
import { fetchWaitGymwiseData } from "../../../redux/prospect-reducers/prospectSlice";
import CommonTable from "../../common-components/common-tables/CommonTable";

const WaitGymwiseTable = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { waitGymwise, waitGymwiseLoading, waitGymwiseError } = useSelector(
    (state) => state.prospects
  );

  // const [isPage, setIsPage] = useState(0);
  // const [pageLimit, setPageLimit] = useState(30);
  // const iniFilters = {
  //   page: isPage + 1,
  //   limit: pageLimit || 30,
  // };
  // const [filters, setFilters] = useState(iniFilters);

  const iniDatas = {
    pagination: [],
    allLeads: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  function getWaitGymwise(filters = {}) {
    dispatch(
      fetchWaitGymwiseData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getWaitGymwise();
  }, []);

  useEffect(() => {
    if (
      !waitGymwiseLoading &&
      !waitGymwiseError &&
      waitGymwise?.status &&
      waitGymwise?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: waitGymwise.data,
        pagination:
          waitGymwise?.pagination?.length > 0 ? waitGymwise.pagination : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [waitGymwiseLoading, waitGymwiseError, waitGymwise]);

  // useEffect(() => {
  //   setFilters((prevs) => ({
  //     ...prevs,
  //     page: isPage + 1,
  //     limit: pageLimit || 30,
  //   }));
  // }, [isPage, pageLimit]);

  const tbColumns = [
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name?.toLowerCase() === "total" ? "bold" : ""
            }`}
          >
            {row?.gym_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "lead_added_today",
      text: "Lead Added Today",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name?.toLowerCase() === "total" ? "tb-badge-success" : ""
            }`}
          >
            {row?.lead_added_today || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_leads",
      text: "total leads",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name?.toLowerCase() === "total" ? "tb-badge-success" : ""
            }`}
          >
            {row?.total_leads || 0}
          </span>
        );
      },
    },
    {
      dataField: "added_to_lead",
      text: "Added to LMS",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name?.toLowerCase() === "total" ? "tb-badge-success" : ""
            }`}
          >
            {row?.added_to_lead || 0}
          </span>
        );
      },
    },
    {
      dataField: "assigned_converted_lead_value",
      text: "Expected Conversion Amount",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name?.toLowerCase() === "total" ? "tb-badge-success" : ""
            }`}
          >
            ₹{convertThenFormat(row?.assigned_converted_lead_value || 0)}
          </span>
        );
      },
    },
    {
      dataField: "assigned_converted_count",
      text: "Converted Leads",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${
              row?.gym_name?.toLowerCase() === "total" ? "tb-badge-success" : ""
            }`}
          >
            ₹{convertThenFormat(row?.assigned_converted_converted_value || 0)} (
            {row?.assigned_converted_count || 0})
          </span>
        );
      },
    },
  ];

  return (
    <div className="mainContainer">
      <div className="common-table-container tb-bordered mt15">
        <CommonTable
          tableData={allDatas.allLeads}
          tableColumns={tbColumns}
          isLoading={waitGymwiseLoading}
        />
      </div>

      {/* <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mod-height-100vh mt15">
        {waitGymwiseLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allLeads}
            tableColumns={tbColumns}
          />
        )}
      </div> */}
      <br />
    </div>
  );
};

export default WaitGymwiseTable;
